import { Component, inject, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { Router } from '@angular/router';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-mdl-delete-task',
  standalone: true, 
  imports: [CommonModule],
  templateUrl: './mdl-delete-task.html',
  styleUrl: './mdl-delete-task.css'
})
export class MdlDeleteTask {
  public api = inject(Api);
    private alertService = inject(AlertService);
  

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public mdl: MatDialogRef<MdlDeleteTask>,
    public router: Router
  ){
    console.log('Modal data recibida:', data);
  }

  delete(){
    console.log('Iniciando eliminación, modo:', this.data.mode);
    
    if(this.data.mode === 'task'){
      this.deleteTask();
    } else if (this.data.mode === 'multiple_tasks') {
      this.deleteMultipleTasks();
    }
  }

  closeMdl(){
    this.mdl.close(false);
  }

  deleteTask(){
    console.log('Eliminando tarea individual:', this.data.tarea_id);
    
    this.api.showLoading();
    this.api.deleteTarea(this.data.tarea_id).subscribe({
      next: (response: any) => {
        console.log('Tarea eliminada - Respuesta:', response);
        setTimeout(() => {
          this.api.hideLoading();
          this.mdl.close(true);
        }, 1000);
      },
      error: (error: any) => {
        this.api.hideLoading()
        if (error?.status===403){
          this.alertService.error('Acceso denegado','No tienes permiso para eliminar tareas')
          this.mdl.close(false);
          return
        }
        this.alertService.error('Error','Ocurrió un problema al eliminar la tarea')

      }
    });
  }

  deleteMultipleTasks(){
    console.log('Eliminando múltiples tareas:', this.data.ids);
    
    this.api.showLoading();
    
    const payload = {
      tarea_ids: this.data.ids
    };

    this.api.deleteTareasMultiples(payload).subscribe({
      next: (response: any) => {
        console.log('Tareas múltiples eliminadas - Respuesta:', response);
        setTimeout(() => {
          this.api.hideLoading();
          this.mdl.close(true);
        }, 1000);
      },
      error: (error: any) => {
        this.api.hideLoading()
        if (error?.status===403){
          this.alertService.error('Acceso denegado','No tienes permiso para eliminar tareas')
          this.mdl.close(false);
          return
        }
        this.alertService.error('Error','Ocurrió un problema al eliminar las tareas')

      }
    });
  }
}